/* ModoSmile · carrito. Lo carga snippets/ms-cart.liquid con defer.
   Los datos (planes, precios y variantes) los emite Liquid en
   snippets/ms-cart-datos.liquid, en window.__msPlanes y window.__msPrecios,
   antes de que este archivo corra. Los estilos, en assets/ms-cart.css.
   La documentacion larga de por que cada cosa esta como esta vive en el
   comentario de cabecera de ms-cart.liquid. Leerlo antes de tocar esto. */
(function () {
  'use strict';
  if (window.__msCartAux) return;
  window.__msCartAux = true;

  var RENEW = '<svg class="ms-renew" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.64-6.36"></path><polyline points="21 3 21 9 15 9"></polyline></svg>';

  var precios = {};
  var variantes = {};
  (window.__msPrecios || []).forEach(function (r) {
    if (!r) return;
    precios[r.vid] = r;
    if (!r.disp) return;
    if (!variantes[r.h]) variantes[r.h] = [];
    variantes[r.h].push(r);
  });

  function cajon() { return document.querySelector('cart-drawer-component'); }
  function dinero(c) { return (c / 100).toFixed(2).replace('.', ',') + '€'; }
  function cerca(e, sel) { return e.target && e.target.closest ? e.target.closest(sel) : null; }
  function seccion() {
    var comp = document.querySelector('cart-items-component');
    return comp ? comp.dataset.sectionId : null;
  }
  function repintarSeccion(j, sec) {
    var comp = document.querySelector('cart-items-component');
    var html = j && j.sections && sec ? j.sections[sec] : null;
    if (!html || !comp) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('cart-items-component');
    if (nuevo) comp.innerHTML = nuevo.innerHTML;
  }

  var datosCarrito = null;
  var cambiando = false;
  var tocando = false;
  var panel = null;

  var SELECTORES = '.ms-susc select, .ms-panel select, .ms-var, .ms-oferta__var';

  /* EL PANEL CUELGA DEL <dialog>, o sea FUERA de .cart-drawer__content, y
     el tema cierra el cajon con cualquier clic que caiga fuera de ese
     contenido. Por eso todo puntero que toque el panel se para aqui, en
     captura sobre document: este oyente se registra antes que el del tema
     (esto va en el head, cart-drawer.js es un modulo y llega despues), asi
     que el tema no llega a verlo. Detener la propagacion no estorba a lo de
     dentro del panel porque toda su logica esta en este mismo oyente y el
     comportamiento nativo del <select> y los botones no depende de que el
     evento siga viajando. */
  ['pointerdown', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (t) {
    document.addEventListener(t, function (e) { if (cerca(e, '.ms-panel')) e.stopPropagation(); }, true);
  });

  /* ---------- cerrojo: nada se repinta con un desplegable abierto -- */
  document.addEventListener('pointerdown', function (e) { if (cerca(e, SELECTORES)) tocando = true; }, true);
  document.addEventListener('focusin', function (e) { if (cerca(e, SELECTORES)) tocando = true; }, true);
  document.addEventListener('focusout', function (e) {
    if (cerca(e, SELECTORES)) setTimeout(function () { tocando = false; }, 150);
  }, true);

  /* ---------- los selectores de la tarjeta de oferta --------------
     El precio de la tarjeta sigue al selector, sea el de variante o el
     de plan. Y el de plan nace SIN name para que por defecto se anada
     como compra unica: se lo ponemos al elegir una suscripcion y se lo
     quitamos al volver. Nunca se manda selling_plan vacio. */
  document.addEventListener('change', function (e) {
    var s = cerca(e, '.ms-oferta__var');
    if (!s) return;
    var op = s.options[s.selectedIndex];
    var tarjeta = s.closest('.ms-oferta');
    var p = tarjeta ? tarjeta.querySelector('.ms-oferta__precio') : null;
    if (p && op && op.getAttribute('data-precio')) p.textContent = op.getAttribute('data-precio');
    if (s.classList.contains('ms-oferta__plan')) {
      if (s.value) s.setAttribute('name', 'selling_plan');
      else s.removeAttribute('name');
    }
  }, true);

  /* ---------- cambiar el plan de una linea ------------------------ */
  function cambiarPlan(clave, cantidad, plan) {
    if (cambiando) return;
    cambiando = true;
    var sec = seccion();
    var cuerpo = { id: clave, quantity: cantidad, selling_plan: plan };
    if (sec) cuerpo.sections = sec;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        repintarSeccion(j, sec);
        cambiando = false;
        refrescar(true);
        colocar();
      })
      .catch(function () { cambiando = false; });
  }

  /* ---------- cambiar la variante de una linea --------------------
     /cart/change.js NO sabe cambiar de variante: solo cantidad y plan.
     Hay que quitar la linea y anadir la otra variante. La linea nueva
     cae al final del carrito; es el precio de poder cambiarla aqui. */
  function cambiarVariante(clave, cantidad, vid) {
    if (cambiando) return;
    cambiando = true;
    var sec = seccion();

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        var cuerpo = { items: [{ id: vid, quantity: cantidad }] };
        if (sec) cuerpo.sections = sec;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cuerpo)
        }).then(function (r) { return r.json(); });
      })
      .then(function (j) {
        repintarSeccion(j, sec);
        cambiando = false;
        refrescar(true);
        colocar();
      })
      .catch(function () { cambiando = false; refrescar(true); });
  }

  /* ---------- el paso intermedio ---------------------------------- */
  function cerrarPanel() {
    if (panel) { panel.remove(); panel = null; }
  }

  function abrirPanel(chip) {
    cerrarPanel();
    var cd = cajon();
    var dlg = cd ? cd.querySelector('dialog.cart-drawer__dialog') : null;
    var ficha = (window.__msPlanes || {})[chip.getAttribute('data-handle')];
    if (!dlg || !ficha || !ficha.planes.length) return;

    var mejor = ficha.planes[0];
    ficha.planes.forEach(function (pl) { if (pl.precio < mejor.precio) mejor = pl; });

    panel = document.createElement('div');
    panel.className = 'ms-panel';

    var tit = document.createElement('p');
    tit.className = 'ms-panel__tit';
    tit.textContent = 'Suscríbete y ahorra';
    panel.appendChild(tit);

    /* el segundo tramo sale de las politicas de precio del plan, no de
       una cifra escrita a mano: hoy es -20% despues de 5 entregas */
    var lineas = ['Ahorras ' + dinero(ficha.base - mejor.precio) + ' en cada entrega'];
    if (mejor.despues > 0 && mejor.tramo > 0) {
      lineas.push('Desde la ' + (mejor.tramo + 1) + '.ª entrega, ' + dinero(mejor.despues));
    }
    lineas.push('Pausa o cancela cuando quieras');
    lineas.push('Envío gratis');

    var ul = document.createElement('ul');
    lineas.forEach(function (t) {
      var li = document.createElement('li');
      li.appendChild(document.createTextNode(t));
      ul.appendChild(li);
    });
    panel.appendChild(ul);

    var sep = document.createElement('div');
    sep.className = 'ms-panel__sep';
    panel.appendChild(sep);

    var fila = document.createElement('div');
    fila.className = 'ms-panel__fila';
    var lab = document.createElement('span');
    lab.textContent = ficha.rotulo || 'Recibir cada';
    var sel = document.createElement('select');
    sel.setAttribute('aria-label', 'Frecuencia de entrega');
    ficha.planes.forEach(function (pl) {
      var o = document.createElement('option');
      o.value = pl.id;
      o.textContent = pl.opcion;
      if (pl.id === mejor.id) o.selected = true;
      sel.appendChild(o);
    });
    fila.appendChild(lab);
    fila.appendChild(sel);
    panel.appendChild(fila);

    var ok = document.createElement('button');
    ok.type = 'button';
    ok.className = 'ms-panel__ok';
    ok.setAttribute('data-clave', chip.getAttribute('data-clave'));
    ok.setAttribute('data-cant', chip.getAttribute('data-cant'));
    ok.textContent = 'Cambiar a suscripción';
    panel.appendChild(ok);

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'ms-panel__no';
    no.textContent = 'Ahora no';
    panel.appendChild(no);

    dlg.appendChild(panel);

    var rc = chip.getBoundingClientRect();
    var rd = dlg.getBoundingClientRect();
    var izq = Math.max(12, Math.min(rc.left - rd.left, rd.width - panel.offsetWidth - 12));
    panel.style.left = izq + 'px';
    panel.style.top = (rc.bottom - rd.top + 8) + 'px';
  }

  document.addEventListener('click', function (e) {
    if (cerca(e, '.ms-panel')) e.stopPropagation();

    if (cerca(e, '.ms-panel__no')) { e.preventDefault(); cerrarPanel(); return; }

    var ok = cerca(e, '.ms-panel__ok');
    if (ok && panel) {
      e.preventDefault();
      var sel = panel.querySelector('select');
      var plan = sel ? Number(sel.value) : 0;
      cerrarPanel();
      if (plan) cambiarPlan(ok.getAttribute('data-clave'), Number(ok.getAttribute('data-cant')), plan);
      return;
    }

    var chip = cerca(e, '.ms-susc-chip');
    if (chip) {
      e.preventDefault();
      if (panel) cerrarPanel();
      else abrirPanel(chip);
      return;
    }

    /* aplicar o quitar un codigo lo hace el tema por su cuenta y no
       avisa: se relee el carrito un poco despues */
    if (cerca(e, '.cart-discount__button, .cart-discount__pill-remove')) {
      setTimeout(function () { refrescar(true); }, 700);
      setTimeout(function () { refrescar(true); }, 1600);
    }

    if (panel && !cerca(e, '.ms-panel')) cerrarPanel();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel) { e.preventDefault(); e.stopPropagation(); cerrarPanel(); }
  }, true);

  document.addEventListener('scroll', function () { if (panel) cerrarPanel(); }, true);

  document.addEventListener('change', function (e) {
    var sel = cerca(e, '.ms-susc select');
    if (sel) {
      tocando = false;
      var v = sel.value;
      cambiarPlan(sel.getAttribute('data-clave'), Number(sel.getAttribute('data-cant')), v === 'no' ? null : Number(v));
      return;
    }
    var vsel = cerca(e, '.ms-var');
    if (vsel) {
      tocando = false;
      cambiarVariante(vsel.getAttribute('data-clave'), Number(vsel.getAttribute('data-cant')), Number(vsel.value));
    }
  }, true);

  /* ---------- pintar los controles de cada linea ------------------ */
  function filas() {
    var cd = cajon();
    if (!cd) return [];
    return Array.prototype.filter.call(cd.querySelectorAll('tr.cart-items__table-row'), function (f) {
      return f.querySelector('td.cart-items__details a.cart-items__title');
    });
  }

  /* DE FILA A LINEA DEL CARRITO, POR CLAVE. No por la URL del producto.
     La version anterior buscaba el item comparando el href del titulo
     con item.url, y eso solo funciona con una linea por producto. Con
     DOS lineas del mismo producto (una de compra unica y otra de
     suscripcion, que Shopify nunca junta porque son lineas distintas)
     las dos filas se quedaban con el PRIMER item y los controles salian
     cambiados. MEDIDO en escritorio el 7 sep.
     cart-products.liquid imprime data-key="{{ item.key }}" en cada <tr>
     y /cart.js devuelve la misma clave en item.key. Es exacta y no
     depende del orden. La reserva por posicion solo entra si el tema
     dejara de imprimir la clave. */
  function itemDeFila(fila) {
    if (!datosCarrito || !datosCarrito.items) return null;
    var clave = fila.getAttribute('data-key');
    if (clave) {
      for (var i = 0; i < datosCarrito.items.length; i++) {
        if (datosCarrito.items[i].key === clave) return datosCarrito.items[i];
      }
    }
    var todas = filas();
    var pos = Array.prototype.indexOf.call(todas, fila);
    if (pos >= 0 && datosCarrito.items[pos]) return datosCarrito.items[pos];
    return null;
  }

  /* EL "ANTES" TACHADO DE LA LINEA: el mayor entre el compare_at de la
     variante y el precio sin plan. Aqui SI entra el precio sin plan,
     porque en una linea de suscripcion es la referencia honesta: es lo
     que costaria esa misma caja comprada suelta. */
  function precioLista(item) {
    var pr = precios[item.variant_id];
    var antes = 0;
    if (pr) {
      if (pr.comparar > item.original_price) antes = pr.comparar;
      if (pr.base > item.original_price && pr.base > antes) antes = pr.base;
    }
    return antes;
  }

  /* EL AHORRO QUE CUENTA PARA EL TOTAL: solo compare_at. El precio sin
     plan NO entra aqui. Motivo, medido el 7 sep contra el checkout:
     Shopify no considera descuento un plan de venta, porque un plan fija
     un precio mas bajo en vez de restar de uno mas alto. Su "AHORRO
     TOTAL" suma codigos, descuentos automaticos y precios comparativos,
     y nada mas. Con el carrito de prueba el cajon decia 19,79 € y el
     checkout 12,79 €, dos pantallas seguidas y dos cifras. Una cifra de
     ahorro que encoge al pasar de pantalla se lee como truco, y la
     Directiva Omnibus mira justo ahi. Decision de Lidia, 7 sep: la
     pildora dice lo mismo que el checkout.
     Los 7,00 € de la suscripcion no se pierden: siguen en la linea, con
     el 44,99 € tachado al lado del 37,99 €. */
  function ahorroContable(item) {
    var pr = precios[item.variant_id];
    if (pr && pr.comparar > item.original_price) return pr.comparar - item.original_price;
    return 0;
  }

  function pintarAntes(fila, item) {
    var celda = fila.querySelector('td.cart-items__price');
    if (!celda) return;
    var antes = precioLista(item);
    var viejo = celda.querySelector('.ms-antes');
    if (antes <= 0) { if (viejo) viejo.remove(); return; }
    var texto = dinero(antes * item.quantity);
    if (viejo) {
      if (viejo.textContent !== texto) viejo.textContent = texto;
      return;
    }
    var s = document.createElement('s');
    s.className = 'ms-antes';
    s.textContent = texto;
    celda.insertBefore(s, celda.firstChild);
  }

  /* selector de variante dentro del carrito, cuando el producto tiene
     mas de una disponible. El tema solo imprime el titulo en un <dl>;
     se oculta y se pone el selector en su lugar */
  function pintarVariante(td, item) {
    var lista = variantes[item.handle];
    if (!lista || lista.length < 2) return;

    var firma = 'var|' + item.key + '|' + item.variant_id + '|' + item.quantity;
    var viejo = td.querySelector('select.ms-var');
    if (viejo && viejo.getAttribute('data-firma') === firma) return;
    if (viejo) viejo.remove();

    var dl = td.querySelector('dl.cart-items__variants');
    if (dl) dl.style.display = 'none';

    var sel = document.createElement('select');
    sel.className = 'ms-var';
    sel.setAttribute('data-clave', item.key);
    sel.setAttribute('data-cant', item.quantity);
    sel.setAttribute('data-firma', firma);
    sel.setAttribute('aria-label', 'Opción del producto');
    lista.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v.vid;
      o.textContent = v.tit;
      if (v.vid === item.variant_id) o.selected = true;
      sel.appendChild(o);
    });

    var t = td.querySelector('a.cart-items__title');
    var anc = t ? t.parentElement : null;
    if (anc && anc.nextSibling) td.insertBefore(sel, anc.nextSibling);
    else td.appendChild(sel);
  }

  function pintarSuscripcion() {
    if (tocando || panel) return;
    var planes = window.__msPlanes || {};
    filas().forEach(function (fila) {
      var td = fila.querySelector('td.cart-items__details');
      var item = itemDeFila(fila);
      if (!td || !item) return;

      /* FUERA LO QUE NO ES DE ESTA LINEA.
         El morph del tema empareja las filas POR POSICION: getNodeKey en
         assets/morph.js solo mira el atributo id, y cart-products.liquid
         no le pone id a los <tr>, solo data-key. Cuando entra una linea
         nueva por arriba (anadir el lapiz desde la banda, por ejemplo) el
         <tr> de la primera linea se reaprovecha para otro producto, y los
         controles que pinta este script se quedan dentro, colgados de la
         fila equivocada. MEDIDO el 7 sep: el lapiz salia con el
         desplegable "Recibir cada 2 meses" de las tiras.
         Cada control lleva data-clave con la clave de SU linea. Si no
         coincide con la de la fila, se va. */
      Array.prototype.forEach.call(
        td.querySelectorAll('.ms-susc-chip, .ms-susc, select.ms-var'),
        function (n) { if (n.getAttribute('data-clave') !== item.key) n.remove(); }
      );

      pintarAntes(fila, item);
      pintarVariante(td, item);

      var ficha = planes[item.handle];
      if (!ficha || !ficha.planes.length) {
        /* producto sin planes de venta, hoy el lapiz: aqui no va ningun
           control de suscripcion, ni propio ni heredado */
        var huerfano = td.querySelector('.ms-susc-chip, .ms-susc');
        if (huerfano) huerfano.remove();
        return;
      }

      var alloc = item.selling_plan_allocation;

      td.querySelectorAll('p').forEach(function (p) {
        if (alloc && p.textContent.trim() === alloc.selling_plan.name) p.style.display = 'none';
      });

      var mejor = null;
      var ahorro = 0;
      var firma;
      if (!alloc) {
        mejor = ficha.planes[0];
        for (var i = 0; i < ficha.planes.length; i++) {
          if (ficha.planes[i].precio < mejor.precio) mejor = ficha.planes[i];
        }
        ahorro = ficha.base - mejor.precio;
        if (ahorro <= 0) return;
        firma = 'chip|' + item.key + '|' + item.quantity + '|' + mejor.id + '|' + ahorro;
      } else {
        firma = 'sel|' + item.key + '|' + item.quantity + '|' + alloc.selling_plan.id;
      }

      var viejo = td.querySelector('.ms-susc-chip, .ms-susc');
      if (viejo && viejo.getAttribute('data-firma') === firma) return;
      if (viejo) viejo.remove();

      var caja;
      if (!alloc) {
        caja = document.createElement('button');
        caja.type = 'button';
        caja.className = 'ms-susc-chip';
        caja.setAttribute('data-clave', item.key);
        caja.setAttribute('data-cant', item.quantity);
        caja.setAttribute('data-handle', item.handle);
        caja.innerHTML = RENEW + '<span>Suscríbete y ahorra ' + dinero(ahorro) + '</span>';
      } else {
        caja = document.createElement('div');
        caja.className = 'ms-susc';
        caja.setAttribute('data-clave', item.key);
        var sel = document.createElement('select');
        sel.setAttribute('data-clave', item.key);
        sel.setAttribute('data-cant', item.quantity);
        sel.setAttribute('aria-label', 'Frecuencia de entrega');
        ficha.planes.forEach(function (pl) {
          var o = document.createElement('option');
          o.value = pl.id;
          o.textContent = pl.opcion;
          if (pl.id === alloc.selling_plan.id) o.selected = true;
          sel.appendChild(o);
        });
        var oc = document.createElement('option');
        oc.value = 'no';
        oc.textContent = 'Cancelar suscripción';
        sel.appendChild(oc);
        caja.innerHTML = RENEW + '<span>' + (ficha.rotulo || 'Recibir cada') + '</span>';
        caja.appendChild(sel);
      }
      caja.setAttribute('data-firma', firma);

      var dl = td.querySelector('dl.cart-items__variants');
      if (dl && dl.nextSibling) td.insertBefore(caja, dl.nextSibling);
      else if (dl) td.appendChild(caja);
      else {
        var t = td.querySelector('a.cart-items__title');
        var anc = t ? t.parentElement : null;
        if (anc && anc.nextSibling) td.insertBefore(caja, anc.nextSibling);
        else td.appendChild(caja);
      }
    });
  }

  /* ---------- resumen: etiqueta, EUR y pildora de ahorro ---------- */
  function pintarResumen() {
    var cd = cajon();
    if (!cd) return;

    cd.querySelectorAll('.cart__total-label').forEach(function (lab) {
      Array.prototype.forEach.call(lab.childNodes, function (n) {
        if (n.nodeType === 3 && /Subtotal/i.test(n.textContent)) {
          n.textContent = n.textContent.replace(/Subtotal/i, 'Total');
        }
      });
      if (!lab.querySelector('.ms-tax')) {
        var t = document.createElement('span');
        t.className = 'ms-tax';
        t.textContent = 'IVA incluido';
        lab.appendChild(t);
      }
    });

    var paseador = document.createTreeWalker(cd, NodeFilter.SHOW_TEXT);
    var textos = [];
    while (paseador.nextNode()) {
      if (/€\s*EUR/.test(paseador.currentNode.textContent)) textos.push(paseador.currentNode);
    }
    textos.forEach(function (n) { n.textContent = n.textContent.replace(/(€)\s*EUR/g, '$1'); });

    var val = cd.querySelector('.cart__total-value');
    if (!val || !datosCarrito) return;

    /* LA PILDORA DICE LO MISMO QUE EL CHECKOUT. Ver ahorroContable():
       compare_at mas los descuentos de codigo, que en cart.js van
       aparte en total_discount y no tocan original_price. El ahorro del
       plan de venta se queda fuera a proposito. */
    var total = 0;
    (datosCarrito.items || []).forEach(function (it) {
      total += ahorroContable(it) * it.quantity;
    });
    if (typeof datosCarrito.total_discount === 'number' && datosCarrito.total_discount > 0) {
      total += datosCarrito.total_discount;
    }

    var pildora = cd.querySelector('#ms-savings');
    if (total <= 0) { if (pildora) pildora.remove(); return; }
    if (!pildora) {
      pildora = document.createElement('span');
      pildora.id = 'ms-savings';
      val.insertBefore(pildora, val.firstChild);
    }
    var txt = 'Ahorras ' + dinero(total);
    if (pildora.textContent !== txt) pildora.textContent = txt;
  }

  /* RELEER EL CARRITO. Antes solo se releia con cart:update y al abrir
     el cajon. Aplicar un codigo de descuento no dispara ninguno de los
     dos: el tema repinta el resumen por su cuenta y datosCarrito se
     quedaba viejo, con total_discount a cero. Resultado: la pildora
     ensenaba solo el ahorro de compare_at y se dejaba el codigo fuera.
     Ahora el observador tambien pide /cart.js, con un freno de 400 ms
     para no encadenar peticiones. Con forzar = true se salta el freno. */
  var ultimaLectura = 0;
  var lecturaEnCola = 0;
  function refrescar(forzar) {
    var ahora = Date.now();
    if (!forzar && ahora - ultimaLectura < 400) {
      if (!lecturaEnCola) {
        lecturaEnCola = setTimeout(function () { lecturaEnCola = 0; refrescar(true); }, 400);
      }
      return;
    }
    ultimaLectura = ahora;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        datosCarrito = c;
        pintarResumen();
        pintarSuscripcion();
      })
      .catch(function () {});
  }

  /* ---------- colocar la banda de recomendados -------------------- */
  var ancha = window.matchMedia('(min-width: 1000px)');
  var observador = null;

  function enganchar() {
    var cd = cajon();
    if (cd && observador) observador.observe(cd, { childList: true, subtree: true });
  }

  function colocar() {
    var cd = cajon();
    if (!cd) return;
    var comp = cd.querySelector('cart-items-component');
    var caja = cd.querySelector('.cart-drawer__upsell');
    if (!comp || !caja) return;
    var destino = ancha.matches ? comp : cd.querySelector('.cart-drawer__items');
    if (!destino || caja.parentElement === destino) return;
    if (observador) observador.disconnect();
    destino.appendChild(caja);
    enganchar();
  }

  var pendiente = 0;
  function programar() {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = 0;
      if (tocando || panel) return;
      colocar();
      pintarResumen();
      pintarSuscripcion();
      refrescar();
    }, 60);
  }

  var intentos = 0;
  (function arrancar() {
    var cd = cajon();
    if (!cd) {
      if (++intentos > 50) return;
      setTimeout(arrancar, 200);
      return;
    }
    observador = new MutationObserver(programar);
    enganchar();
    colocar();
    refrescar(true);

    var d = cd.querySelector('dialog');
    if (d) {
      new MutationObserver(function () { if (d.open) refrescar(true); else cerrarPanel(); })
        .observe(d, { attributes: true, attributeFilter: ['open'] });
    }
    document.addEventListener('cart:update', function () { refrescar(true); });

    if (ancha.addEventListener) ancha.addEventListener('change', colocar);
    else if (ancha.addListener) ancha.addListener(colocar);
  })();
})();